<template>
    <div class="settings">
        <CrmConnectionPendingFinal v-if="!isChange" />
        <template v-else>
            <v-row class="mx-0 my-10">
                <p>У данного источника нет настроек, все настраивается автоматически</p>
            </v-row>
            <v-row justify="end" class="ma-0">
                <v-btn @click="goToProject" outlined class="mr-3 mt-2 cancel-btn">Завершить</v-btn>
            </v-row>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import cfg from '../../../../config'
import CrmConnectionPendingFinal from '@/components/project/onBoarding/CrmConnectionPendingFinal.vue'
export default {
    name: 'ProfSalonConnectorSettings',
    props: {
        isChange: {
            type: Boolean,
            default: false,
        },
        connector: {
            type: Object,
            default: null,
        },
    },
    components: { CrmConnectionPendingFinal },
    data: () => ({
        cfg,
    }),
    computed: {
        ...mapState('project', ['loggedAddingConnector']),
    },

    methods: {
        goToProject() {
            this.$parent.$emit('goToProject')
        },
    },
}
</script>
<style lang="sass" scoped>
.cancel-btn
    border-color: #0000001F !important
</style>
